// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_tn-0";
export var checkoutRateBadgeLink = "_tn-1";